<template>
  <div class="entered-transfer">
    <div class="ly-card hd">
      <el-input style="width: 200px" clearable v-model="searchFormData.query" class="m-r-10" placeholder="姓名/班级名称/班级代码"></el-input>
      <el-date-picker
        v-model="date"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        value-format="yyyy-MM-dd"
        clearable
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-button @click="search" type="primary">查询</el-button>
      <el-button type="primary" @click="exportExcel">导出</el-button>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:new_class_name="row">
        <el-button @click="showClass(row,'new')" type="text" size="mini">{{ row.new_class_name }}</el-button>
      </template>
      <template v-slot:original_class_name="row">
        <el-button @click="showClass(row,'old')" type="text" size="mini">{{ row.original_class_name }}</el-button>
      </template>
    </ly-table>
    <el-dialog title="课程表" :visible.sync="dialogVisibleSc" width="1400px">
      <class-schedule :class_mode="scTime.class_mode" :class_id="scTime.class_id" />
    </el-dialog>
    <el-dialog title="班级信息" :visible.sync="dialogVisibleDetail" width="1000px">
      <class-inf-detail-list :isFetch="true" @showSc="showSc" :defaultFormItemClass="defaultFormItemClass"></class-inf-detail-list>
    </el-dialog>
  </div>
</template>
<script>
import { DatePicker, Input, Dialog } from 'element-ui';
import LyTable from '@/components/LyTable';
import { transferRecordTable } from '@/utils/tableHeader';
import { finance } from '@/api';
import ClassInfDetailList from '@/components/ClassInfDetail/list';
import ClassSchedule from '@/components/ClassSchedule';
import utils from '@/utils/utils';

export default {
  name: 'statisticsRegister',
  components: { ElDatePicker: DatePicker, ElInput: Input, LyTable, ElDialog: Dialog, ClassInfDetailList, ClassSchedule },
  data() {
    return {
      searchFormData: {
        query: '',
        start_time: '',
        end_time: ''
      },
      tableHeader: transferRecordTable,
      getTableData: finance.transferRecord,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      date: [],
      defaultFormItemClass: {},
      dialogVisibleDetail: false,
      dialogVisibleSc: false,
      scTime: {},
      classSendData: {}
    };
  },
  mounted() {
    this.search();
  },
  computed: {
    label() {
      return value => {
        if (value) return this.terms.find(item => item.value === value).label;
        return '';
      };
    }
  },
  methods: {
    search() {
      const temp = {
        ...this.searchFormData,
        start_time: this.date && this.date.length ? `${this.date[0]} 00:00:00` : -1,
        end_time: this.date && this.date.length ? `${this.date[1]} 23:59:59` : -1
      };
      this.searchFormData = {
        ...temp
      };
      this.$refs.lyTable.setData();
    },
    showClass(row, sta) {
      if (sta === 'new') {
        this.classSendData = {
          ...row,
          id: row.new_class_id
        };
        this.defaultFormItemClass = { id: row.new_class_id };
      } else {
        this.classSendData = {
          ...row,
          id: row.original_class_id
        };
        this.defaultFormItemClass = { id: row.original_class_id };
      }
      this.dialogVisibleDetail = true;
    },
    showSc(row) {
      this.dialogVisibleSc = true;
      this.scTime = {
        class_mode: row.class_mode,
        class_id: this.classSendData.id
      };
    },
    exportExcel() {
      const params = { ...this.searchFormData };
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null) delete params[key];
      });
      finance
        .exportTransferRecord({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '转班记录统计');
        });
    }
  }
};
</script>
<style lang="less">
.entered-transfer {
  .hd {
    .el-select {
      width: 100px;
    }
    .m-r-10{
      width:140px;
    }
    .el-date-editor{
      margin-right:10px;
    }
  }
}
</style>
